"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardWeatherOption_1 = require("./actions/discardWeatherOption");
var saveWeatherOption_1 = require("./actions/saveWeatherOption");
var WeatherFull_1 = require("./components/WeatherFull");
var isWeatherOptionDirty_1 = require("./utils/isWeatherOptionDirty");
var React = require("react");
var WeatherOption = {
    key: 'weather',
    titleStringKey: 'optionTitle_weather',
    searchTermsStringKey: 'optionTitle_weather',
    fullOptionFormSettings: {
        render: function () { return React.createElement(WeatherFull_1.default, null); },
        isDirty: isWeatherOptionDirty_1.default,
        onSave: saveWeatherOption_1.default,
        onDiscard: discardWeatherOption_1.default,
    },
};
exports.default = WeatherOption;
//# sourceMappingURL=WeatherOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/calendar/owa-weather-option/lib/WeatherOption.js
// module id = 5246
// module chunks = 2